import { State, Getter, } from 'vuex-class';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { getUserId, getUserName, setAuthToken, setUserId, setUserName } from '@/utils/cookies';

import {routesComputed} from '@/router/index';
import { LayoutMgr } from '@/api/index';
import { Regexp } from '@/utils/validate';

@Component({
  components: {}
})
export default class Layout extends Vue {
  private routes: object[] = routesComputed; // 路由
  private defaultActive: string = ''; // 默认选中菜单
  private userId: any = getUserId();
  private userName: any = getUserName();
@Watch('$route')
  private routeChange() {
    this.defaultActive = this.$route.matched[1].path as string;
  }
  private mounted() {
    this.routeChange();
  }

  /********** 个人信息、修改密码、退出登录 **********/

  // 个人信息相关信息
  private editUser: any = {
    formVisible: false, // 模态框是否展示
    invalid: true, // 保存按钮是否可点击
    user: {}, // 用户对象
    dicts: {}, // 性别以及状态字典表
    roleNames: '', // 角色名称
  };
  // 修改密码相关信息
  private updatePassword: any = {
    formVisible: false, // 模态框是否展示
    invalid: true, // 保存按钮是否可点击
    oldPassword: '', // 旧密码
    newPassword: '', // 新密码
    confirmPassword: '' // 确认密码
  };
  // 登录用户下拉框点击事件
  private handleCommand(command) {
    if (command === 'editUser') {
      this.editUserFun();
    } else if (command === 'updatePassward') {
      this.updatePasswardFun();
    } else if (command === 'returnLogin') {
      this.returnLoginFun();
    }
  }
  // 编辑用户
  private editUserFun() {
    this.editUser.formVisible = true;
    this.getUserById();
    this.getDictList();
  }
  // 修改密码
  private updatePasswardFun() {
    this.updatePassword.formVisible = true;
  }
  // 退出登录
  private returnLoginFun() {
    setAuthToken('');
    setUserId('');
    setUserName('');
    this.$router.push({name: 'login'});
  }
  // 获取用户的信息
  private getUserById() {
    LayoutMgr.getUserById(this.userId).then(res => {
      this.editUser.user = res.data;
      this.editUser.roleNames = res.data.roleList.map(item => item.roleName).join(',');
    });
  }
  // 获取字典表
  private getDictList() {
    LayoutMgr.getDicts('usr_sex').then(res => {
      this.$set(this.editUser.dicts, 'usr_sex', res.data);
    });
  }
  // 表单验证规则
  get editUserRules(): object {
    return {
      mobile: [ Regexp().phone ],
      email: [ Regexp().email ]
    };
  }
  get updatePasswordRules(): object {
    return {
      oldPassword: [ Regexp().required ],
      newPassword: [ Regexp().required ],
      confirmPassword: [ Regexp().required, { validator: this.validatePassword, trigger: 'blur' }]
    };
  }
  private validatePassword(rule, value, callback) {
    if (value === '') {
      callback(new Error('请再次输入密码'));
    } else if (value !== this.updatePassword.newPassword) {
      callback(new Error('两次输入密码不一致!'));
    } else {
      callback();
    }
  }
  // 实时验证表单 判断确定按钮是否可用
  private editUserValidateForm() {
    this.editUser.invalid = (this.$refs.editUserForm as any).fields.some((e: any) =>
      e.isRequired ? e.validateState !== 'success' : e.validateState === 'error'
    );
  }
  private updatePasswordValidateForm() {
    this.updatePassword.invalid = (this.$refs.updatePasswardForm as any).fields.some((e: any) =>
    e.isRequired ? e.validateState !== 'success' : e.validateState === 'error'
  );
  }
  // 保存用户
  private saveUser() {
    const roles: object[] = [];
    for (const each of this.editUser.user.roleList) {
      roles.push({ roleId: each.roleId });
    }
    const param = {
      userId: this.editUser.user.userId,
      userName: this.editUser.user.userName,
      mobile: this.editUser.user.mobile,
      email: this.editUser.user.email,
      roleList: roles,
      status: this.editUser.user.status,
      sex: this.editUser.user.sex,
      description: this.editUser.user.description
    };
    LayoutMgr.editUser(param).then(res => {
      this.editUser.formVisible = false;
      this.editUser.invalid = true;
      setTimeout(() => {
        (this.$refs.editUserForm as any)?.clearValidate();
      }, 300);
    });
  }
  // 保存密码
  private savePassword() {
    LayoutMgr.updatePassword(
    this.updatePassword.newPassword,
    this.updatePassword.oldPassword
    ).then(res => {
      this.updatePassword.formVisible = false;
      this.updatePassword.invalid = true;
      this.returnLoginFun();
    });
  }
}
